module.exports = __webpack_public_path__ + "static/media/grand_mum_walk01.03d93c19.png";